import React, { useState } from 'react';
import { useAuth } from '../AuthContext'; // Go up one level to find AuthContext
import { useNavigate, Link } from 'react-router-dom';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the page from reloading
    setError(''); // Clear any previous errors

    try {
      const result = await login(username, password);
      if (result.success) {
        navigate('/dashboard');
      } else {
        // If it fails, show the error.
        setError(result.error || 'Failed to log in. Please check your credentials.');
      }
      // If login is successful, the AuthContext will update and App.js will show the main app automatically.
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
    }
  };

  return (
    <div className="bg-slate-100 min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl border border-slate-200">
        <div className="mb-4">
          <Link to="/" className="text-xs font-semibold text-slate-500 hover:text-emerald-600 inline-flex items-center gap-1 transition-colors">
            &larr; Back to Home (回首頁)
          </Link>
        </div>
        <div className="text-center mb-6">
          <img 
            src="/logo192.png" 
            alt="Irie Roots Logo" 
            className="w-14 h-14 rounded-2xl object-cover mx-auto mb-2.5 shadow-md shadow-emerald-500/20 border border-slate-100" 
          />
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Staff Sign In</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Teacher & Admin Management Portal (愛瑞美語)</p>
        </div>
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
              <span className="block sm:inline">{error}</span>
            </div>
          )}
          <div className="mb-4">
            <label className="block text-gray-700 dark:text-gray-300 mb-2" htmlFor="username">
              Username
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 dark:text-gray-300 mb-2" htmlFor="password">
              Password
            </label>
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="mb-6 flex items-center">
            <input
              id="show-password"
              type="checkbox"
              checked={showPassword}
              onChange={() => setShowPassword(!showPassword)} // Toggle the state on change
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 dark:border-gray-600 rounded"
            />
            <label htmlFor="show-password" className="ml-2 block text-sm text-gray-900 dark:text-gray-100">
              Show Password
            </label>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition-colors"
          >
            Login
          </button>
        </form>
        <div className="text-center mt-4">
          <Link to="/forgot-password" className="text-xs font-semibold text-slate-500 hover:text-emerald-600 transition-colors">
            Forgot your password?
          </Link>
        </div>
      </div>
    </div>
  );
}